import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { bindActionCreators } from 'redux';
import randomstring from 'uuid/v4';

import Fab from '@material-ui/core/Fab';

import InsertPhoto from '@material-ui/icons/InsertPhoto';
import Timelapse from '@material-ui/icons/Timelapse';
import Warning from '@material-ui/icons/Warning';

import * as actions from '../../../actions/xhef.actions';
import Snackbar from '../../labels/Snackbar';
import src from '../../../images/progress_clean.png';
import { AddIcon } from '../../../images/icons/WrapSvg';

import {
    formatDateTime,
    timeDiference,
    getTotalSecondsDiference,
    percentage,
} from '../../../functions/time';

// eslint-disable-next-line
import style from './_styles.css';

function getMachineName(machines, id) {
    const machine = machines.find((f) => f.id === id);
    if (machine) {
        return machine.nombre;
    }
    return '';
}

class Command extends React.Component {
    state = {};

    static getDerivedStateFromProps(props, state) {
        const { xef, tab } = props;
        const data =
            xef && xef.producciones
                ? xef.producciones.filter(
                    (f) =>
                        f.cerrada === null &&
                        (tab === 0 || f.estacion === tab) &&
                        f.produciendo === null,
                )
                : [];
        const avisocapacidad = xef ? xef.avisocapacidad : false;
        const productos = xef && xef.productos ? xef.productos : [];

        if (data !== state.data || avisocapacidad !== state.avisocapacidad) {
            state.data = data;
            state.avisocapacidad = avisocapacidad;
            state.productos = productos;
            return state;
        }
        return null;
    }

    handleClick = (item) => {
        if (
            this.state.lastrun === undefined ||
            getTotalSecondsDiference(this.props.xef_reference_time, this.state.lastrun) > 3
        ) {
            this.props.handleOpenRun('run', item);
            this.setState({ lastrun: this.props.xef_reference_time });
        }
    };

    render() {
        const { data, error, avisocapacidad, productos } = this.state;

        const ItemPreparacion = (item) => {
            const producto = productos.find(f => f.id === item.idProducto);
            const style = {
                backgroundSize:
                    percentage(item.nextrun, this.props.xef_reference_time, item.preparando) +
                    '% auto',
                backgroundRepeat: 'repeat-y',
                backgroundImage: 'url(' + src + ')',
                backgroundPositionY: 'center',
            };
            return (
                <div
                    key={randomstring()}
                    style={style}
                    className={
                        'flex_full_row padding_4 boxShadow align_center margin_bottom_12  hand ' +
                        (item.preparando ? 'bg_light-purple c_dark_grey_blue ' : 'bg_cornflower_blue c_white ')
                    }
                    onClick={(event) => this.handleClick(item)}
                >
                    {(producto && item && producto.foto) ? (
                        <img
                            src={producto.foto}
                            alt={item.idProducto}
                            style={{ width: 42, height: 42 }}
                            className="borderRadius bg_white margin_right_6"
                        />
                    ) : (
                            <InsertPhoto style={{ fontSize: 42 }} className="c_white margin_right_6" />
                        )}
                    <div className="flex_full_column">
                        <div className="height100 flex_full_row">
                            <span className="flex_auto_row barlowcondensed_light_percentage padding_right_6">
                                {item.cantidad}
                            </span>
                            <span className="flex_full_row barlowcondensed_light_percentage uppercase ">
                                {item.nomProducto}
                            </span>
                        </div>
                        <div className="flex_auto_row">
                            <span className="flex_full_row barlow_regular_small height100 uppercase ">
                                {getMachineName(this.props.machines, item.idMaquina)}
                            </span>
                            {item.preparando ? (
                                <div className="flex_auto_row">
                                    <span className="flex_full_row barlowcondensed_medium elements_from_right padding_right_6  ">
                                        {formatDateTime(item.preparando)}
                                    </span>
                                    <span className="flex_full_row barlowcondensed_small elements_from_right nowrap">
                                        <Timelapse className="margin_right_6" fontSize="small" />
                                        {timeDiference(item.nextrun, this.props.xef_reference_time)}
                                    </span>
                                </div>
                            ) : (
                                    <div className="flex_auto_row">
                                        <span className="flex_full_row barlowcondensed_medium elements_from_right padding_right_6 ">
                                            {formatDateTime(item.creada)}
                                        </span>
                                        <span className="flex_auto_row barlowcondensed_medium elements_from_right nowrap">
                                            <Timelapse className="margin_right_6" fontSize="small" />
                                            {timeDiference(this.props.xef_reference_time, item.creada)}
                                        </span>
                                    </div>
                                )}
                        </div>
                    </div>
                </div>
            );
        };

        const Item = (item) => {
            const producto = productos.find(f => f.id === item.idProducto);
            return (
                <div
                    key={randomstring()}
                    className={
                        'flex_full_row padding_4 boxShadow align_center margin_bottom_12 hand ' +
                        (item.preparando ? 'bg_light-purple c_dark_grey_blue ' : 'bg_cornflower_blue c_white ')
                    }
                    onClick={(event) => this.handleClick(item)}
                >
                    {(producto && item && producto.foto) ? (
                        <img
                            src={producto.foto}
                            alt={item.idProducto}
                            style={{ width: 42, height: 42 }}
                            className="borderRadius bg_white margin_right_6"
                        />
                    ) : (
                            <InsertPhoto style={{ fontSize: 42 }} className="c_white margin_right_6" />
                        )}
                    <div className="flex_full_column">
                        <div className="height100 flex_full_row">
                            <span className="flex_auto_row barlowcondensed_light_percentage padding_right_6">
                                {item.cantidad}
                            </span>
                            <span className="flex_full_row barlowcondensed_light_percentage uppercase ">
                                {item.nomProducto}
                            </span>
                        </div>
                        <div className="flex_auto_row">
                            <span className="flex_full_row barlow_regular_small height100 uppercase ">
                                {getMachineName(this.props.machines, item.idMaquina)}
                            </span>
                            {item.preparando ? (
                                <div className="flex_auto_row">
                                    <span className="flex_full_row barlowcondensed_medium elements_from_right padding_right_6  ">
                                        {formatDateTime(item.preparando)}
                                    </span>
                                    <span className="flex_full_row barlowcondensed_small elements_from_right nowrap">
                                        <Timelapse className="margin_right_6" fontSize="small" />
                                        {timeDiference(item.nextrun, this.props.xef_reference_time)}
                                    </span>
                                </div>
                            ) : (
                                    <div className="flex_auto_row">
                                        <span className="flex_full_row barlowcondensed_medium elements_from_right padding_right_6 ">
                                            {formatDateTime(item.creada)}
                                        </span>
                                        <span className="flex_auto_row barlowcondensed_medium elements_from_right nowrap">
                                            <Timelapse className="margin_right_6" fontSize="small" />
                                            {timeDiference(this.props.xef_reference_time, item.creada)}
                                        </span>
                                    </div>
                                )}
                        </div>
                    </div>

                </div>
            );
        };

        return (
            <div id="xhef" className="flex_full_column boxShadow bg_ice_blue">
                <div className="flex_auto_row barlow_semibold c_dark_grey_blue padding_top_6 padding_bottom_12 padding_left_6 padding_right_6">
                    <span className="flex_full_row no-wrap">
                        <FormattedMessage id="xhef_command" />
                    </span>
                    <div className="flex_auto_row elements_from_right">
                        {avisocapacidad && <Warning className="c_golden_yellow margin_right_12" />}
                        <Fab
                            onClick={() => this.props.handleOpenCommand('command', true)}
                            color="primary"
                            size="small"
                            className="xef_add_img"
                        >
                            <AddIcon />
                        </Fab>
                    </div>
                </div>
                <div className="flex_full_column padding_top_6 padding_bottom_12 padding_left_6 padding_right_6 overflow_y_scroll">
                    {data &&
                        data.length > 0 &&
                        data
                            .filter((f) => f.preparando)
                            .sort((a, b) => (a.orden > b.orden ? 1 : -1))
                            .map((d) => {
                                return <ItemPreparacion key={randomstring()} {...d} />;
                            })}
                    {data &&
                        data.length > 0 &&
                        data
                            .filter((f) => !f.preparando)
                            .sort((a, b) => (a.orden > b.orden ? 1 : -1))
                            .map((d) => {
                                return <Item key={randomstring()} {...d} />;
                            })}
                </div>
                {error && (
                    <Snackbar
                        open={true}
                        variant="error"
                        text={error}
                        nonavbar={true}
                        onClose={this.handleClose}
                    />
                )}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        info: state.info,
    };
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(Command));



// WEBPACK FOOTER //
// ./src/components/complex/xhef/Command.js